(function($, Drupal) {
  'use strict';

  Drupal.behaviors.sidebar = {
    attach: function(context, settings) {
      // checks if received item is in viewport
      function isInViewport($element) {
        let elementTop = $element.offset().top;
        let elementBottom = elementTop + $element.outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }

      let $sidebar_share = $('#js-content-share');
      let $site_header = $('#site-header');
      let $page_header = $('#page-header');
      let $content_header = $('#js-content-top');
      let $footer = $('#footer');
      // Adds dynamic sticky scroll to share sidebar element
      function stickyShare() {
        if (!isInViewport($footer)) {
          if ($(window).width() > 768) {
            let $scroll_top, $header_offset, $distance, $share_spacer;
            $scroll_top = $(window).scrollTop();
            $header_offset = $content_header.offset().top;
            $distance = ($header_offset - $scroll_top - 32);

            $share_spacer = $scroll_top - $page_header.height() + 'px';
            if ($distance <= $site_header.height()) {
              $sidebar_share.css('top', $share_spacer);
            }
            else {
              $sidebar_share.attr('style', '');
            }
          }
        }
      }

      let $sidebar_block_toggle = $('.js-toggle-sidebar-block');
      if ($sidebar_block_toggle.length !== 0) {
        $sidebar_block_toggle.once('toggles-block-add').on('click', function() {
          $(this).toggleClass('expanded');
          $(this).siblings('div').slideToggle(300);
        });
      }

      // Reset styles for sidebar if window width is less the 768px
      if ($('.page-node-type-page, .page-node-type-symposium, .page-node-type-multimedia').length !== 0) {
        $(window).resize(function() {
          if ($(window).width() < 768) {
            $sidebar_share.attr('style', '');
          }
        });

        $(window).scroll(function() {
          if ($(window).width() > 768) {
            stickyShare();
          }
        });

        stickyShare();
      }
    }
  };
})(jQuery, Drupal);
